import { z } from 'zod'
import { zodErrors } from '~/utils/zodUtils'
import { match } from 'ts-pattern'
import { en, nl } from 'zod/locales'

export default defineNuxtPlugin(({ $pinia }) => {
  const localeStore = useLocaleStore($pinia)

  watch(
    () => localeStore.localeIsDutch,
    (newValue) => {
      const zodLocale = newValue ? nl() : en()

      z.config({
        ...zodLocale,
        customError: (issue) => {
          let message = issue.message

          // Checks multiple error codes to add default error messages where applicable.
          // Uncomment the lines below to enable logging of unknown error types
          if (issue.code === 'too_small') {
            if (issue.type === 'string') {
              message = zodErrors.value.emptyString()
            } else if (issue.type === 'number') {
              message = zodErrors.value.min(Number(issue.minimum))
            }
            // else {
            //   console.log(issue)
            // }
          } else if (issue.code === 'too_big') {
            if (issue.origin === 'number') {
              message = zodErrors.value.max(Number(issue.maximum))
            } else if (issue.origin === 'string') {
              message = zodErrors.value.maxString(Number(issue.maximum))
            }
          } else if (issue.code === 'invalid_type') {
            message = match(issue.expected)
              .with('int', () => zodErrors.value.int())
              .with('number', () => zodErrors.value.number())
              .otherwise(() => {
                // console.log(issue)
                return zodErrors.value.required().error
              })
          } else if (issue.code === 'invalid_value') {
            if (!issue.input) {
              message = zodErrors.value.required().error
            }
          } else if (issue.code === 'invalid_format') {
            if (issue.format === 'email') {
              message = zodErrors.value.email()
            } else if (issue.format === 'emoji') {
              message = zodErrors.value.emoji()
            }
          } else if (issue.code === 'not_multiple_of') {
            message = zodErrors.value.multipleOf(issue.divisor)
          }
          // else if (issue.code !== z.ZodIssueCode.custom) {
          //   console.log(issue)
          // }
          return message
        }
      })
    },
    { immediate: true }
  )
})
